import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppointmentBookingSource, IDigitalChecklist, IDigitalChecklistAppointment, IResponse } from '@signal/asp-data-commons';
import { Observable } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { DealerState } from '../../store/dealer/dealer.reducer';
import { selectDealerCode } from '../../store/dealer/dealer.selectors';
import { environment } from './util.service';

@Injectable({
  providedIn: 'root'
})
export class DeliveryChecklistService {

  private readonly apiRoot: string;

  constructor(private readonly http: HttpClient,
    private readonly dealerState: Store<DealerState>) {
    this.apiRoot = environment.digiChecklistApi;
  }

  getChecklistSummary(checklistSummaryStatus: string,pageNumber:number,pageSize:number,filters?:any): Observable<IResponse<any>> {
    const params=filters ? new HttpParams().set('filters',JSON.stringify(filters)) : null;
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      const url = `${this.apiRoot}api/digital-checklist/${dealerCode}/fetch-checklist-list?checkListStatus=${checklistSummaryStatus}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
      return this.http.get(url,{params}).pipe(
        map((data: any) => {
          return data;
        }
        )
      );
    }
    ))
  };

  getChecklist(fuelType: string): Observable<IResponse<IDigitalChecklist[]>> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      const url = `${this.apiRoot}api/digital-checklist/${dealerCode}/fetch-default-checklist?fuelType=${fuelType}`;
      return this.http.get(url).pipe(
        map((data: any) => {
          return data;
        }
        )
      );
    }));
  }

  getChecklistsForVin(vin: string): Observable<IResponse<IDigitalChecklistAppointment>> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      const url = `${this.apiRoot}api/digital-checklist/${dealerCode}/vin-lookup/${vin}`;
      return this.http.get(url).pipe(
        map((data: any) => {
          return data;
        }
        )
      );
    }))
  }

  createDigiCheckReq(checkReq: IDigitalChecklistAppointment): Observable<IResponse<IDigitalChecklistAppointment>> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      const url = `${this.apiRoot}api/digital-checklist/${dealerCode}/create-checklist`;
      return this.http.post(url, checkReq).pipe(
        map((data: any) => {
          return data;
        }
        )
      );
    }
    ))
  };

  updateDigiChekReq(checkReq: IDigitalChecklistAppointment): Observable<IResponse<IDigitalChecklistAppointment>> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      const url = `${this.apiRoot}api/digital-checklist/${dealerCode}/update-checklist/${checkReq.digichkId}`;
      return this.http.put(url, checkReq).pipe(
        map((data: any) => {
          return data;
        }
        )
      );
    }
    ))
  };

  getSignature(id: string, idType: string) {
    const url = `${this.apiRoot}fetch-signature/${id}?userIdType=${idType}`;
    return this.http.get(url).pipe(
      map((data: any) => {
        return data;
      }
      )
    );
  }

  createSignature(data) {
    const url = `${this.apiRoot}upload-signature`;
    return this.http.post(url, data).pipe(
      map((data: any) => {
        return data;
      }))
  }

  getEditData(digiChekId: string): Observable<IResponse<IDigitalChecklistAppointment>> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(code => {
      return this.http.get(`${this.apiRoot}api/digital-checklist/${code}/fetch-checklist/${digiChekId}`).pipe(
        map((data: IResponse<IDigitalChecklistAppointment>) => {
          return data;
        }))
    }));

  }
  
  cancelCheckList(digitalChecklist: IDigitalChecklistAppointment): Observable<IResponse<IDigitalChecklistAppointment>> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(code => {
      return this.http.delete(`${this.apiRoot}api/digital-checklist/${code}/delete-checklist/${digitalChecklist.digichkId}`).pipe(
        map((data: IResponse<IDigitalChecklistAppointment>) => {
          return data;
        }))
    }));
  }

  getPdfData(checklistId: string, path: string) {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(code => {
      return this.http.get(`${this.apiRoot}generatePdf?dealerCode=${code}&digichkId=${checklistId}&path=${path}`).pipe(
        map((data: any) => {
          return data;
        }))
    }));
  }

  sendChecklistPdf(data: any,type:string) {
    return this.http.post(`${this.apiRoot}sendemailtocustomer?type=${type}`,data).pipe(
      map((data: any) => {
        return data;
      }));
  }

  fetchArchivedChecklists(year: number, month: number, pageNumber: number, pageSize: number,filters?:any): Observable<any> {
    const params=filters ? new HttpParams().set('filters',JSON.stringify(filters)) : null;
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      const url=`${this.apiRoot}fetch-archival-digital-checklist-year-month/${dealerCode}?pageNumber=${pageNumber}&pageSize=${pageSize}&year=${year}&month=${month}`;
        return this.http.get(url,{params}).pipe(
            map((data: any) => {
              return data
            })
        );
    }
    ));
};

  resubmitDigiCheckReq(checkReq: IDigitalChecklistAppointment): Observable<IResponse<any>> {
      const url = `${this.apiRoot}resubmit-dc/${checkReq.digichkId}`;
      return this.http.put(url, checkReq).pipe(
        map((data: any) => {
          return data;
        })
      );
  };
}
